import { useCurrentUser, useSchoolConfiguration } from 'shared/hooks';
import { AdvertisingCampaignAdKeyFilter, useAdViewCreateMutation } from 'shared/graphql';

/**
 * Custom hook to create an ad view.
 *
 * This hook provides a function to create an ad view by executing a mutation.
 * It requires the current user and school configuration to be available.
 */
export function useCreateAdView() {
  const { user } = useCurrentUser();
  const { data: school } = useSchoolConfiguration();

  const [execute, { loading }] = useAdViewCreateMutation();

  const mutate = async (ad: AdvertisingCampaignAdKeyFilter) => {
    if (!user?.id || !school?.id || !ad.id) {
      return;
    }

    await execute({
      variables: {
        user: user.id,
        // Relate with the school where it was viewed.
        // https://github.com/jebelapp/jebel/issues/1697
        school: school.id,
        ad: ad.id,
      },
    });
  };

  return {
    mutate,
    loading,
  };
}
